import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import pb from '../../../lib/pocketbase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEnvelope, faLock, faUser, faArrowRight, faPhone } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import styles from './AuthModal.module.css';

function AuthModal() {
    const { isAuthModalOpen, closeAuthModal, modalView, setModalView } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);

    if (!isAuthModalOpen) return null;

    const isLogin = modalView === 'login';

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await pb.collection('users').authWithPassword(email, password);
            toast.success('Bon retour parmi nous !');
            closeAuthModal();
            // Optional: window.location.reload() or handle state
        } catch (err) {
            toast.error('Identifiants invalides.');
            console.error('Login error:', err);
        }
        setLoading(false);
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (password !== passwordConfirm) {
            toast.error('Les mots de passe ne correspondent pas.');
            return;
        }
        setLoading(true);
        try {
            await pb.collection('users').create({
                email,
                password,
                passwordConfirm,
                name,
                phone,
                profile_type: 'visitor',
                emailVisibility: true
            });
            await pb.collection('users').requestVerification(email);
            toast.success('Inscription réussie ! Vérifiez vos emails.');
            setModalView('login');
        } catch (err) {
            toast.error('Erreur lors de l\'inscription.');
            console.error('Registration error:', err);
        }
        setLoading(false);
    };

    return (
        <div className={styles.modalOverlay} onMouseDown={(e) => { if (e.target === e.currentTarget) closeAuthModal(); }}>
            <div className={styles.modalContent}>
                <button className={styles.closeButton} onClick={closeAuthModal}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>

                <div className={styles.modalHeader}>
                    <div className={styles.logoContainer}>
                        <img src="/images/logo.png" alt="Maison Quinard" className={styles.logo} />
                    </div>
                    <h2>{isLogin ? 'Bon Retour' : 'Rejoindre l\'Aventure'}</h2>
                    <p>{isLogin ? 'Connectez-vous pour suivre vos projets' : 'Créez votre compte en quelques secondes'}</p>
                </div>

                <form onSubmit={isLogin ? handleLogin : handleRegister} className={styles.authForm}>
                    {!isLogin && (
                        <>
                            <div className={styles.inputGroup}>
                                <label><FontAwesomeIcon icon={faUser} /> Nom complet</label>
                                <input
                                    type="text"
                                    placeholder="Jean Dupont"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label><FontAwesomeIcon icon={faPhone} /> Téléphone</label>
                                <input
                                    type="tel"
                                    placeholder="06 12 34 56 78"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    required
                                />
                            </div>
                        </>
                    )}

                    <div className={`${styles.inputGroup} ${isLogin ? styles.inputGroupEmail : (!isLogin ? styles.inputGroupEmail : '')}`}>
                        <label><FontAwesomeIcon icon={faEnvelope} /> Email</label>
                        <input
                            type="email"
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className={`${styles.inputGroup} ${isLogin ? styles.inputGroupEmail : ''}`}>
                        <label><FontAwesomeIcon icon={faLock} /> Mot de passe</label>
                        <input
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {!isLogin && (
                        <div className={styles.inputGroup}>
                            <label><FontAwesomeIcon icon={faLock} /> Confirmation</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                value={passwordConfirm}
                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                required
                            />
                        </div>
                    )}

                    <button type="submit" className={styles.submitButton} disabled={loading}>
                        {loading ? (
                            <span className={styles.loader}></span>
                        ) : (
                            <>
                                {isLogin ? 'Se connecter' : 'Créer mon compte'}
                                <FontAwesomeIcon icon={faArrowRight} className={styles.btnIcon} />
                            </>
                        )}
                    </button>
                </form>

                <div className={styles.modalFooter}>
                    <p>
                        {isLogin ? "Nouveau ici ?" : "Déjà membre ?"}
                        <button
                            className={styles.toggleBtn}
                            onClick={() => setModalView(isLogin ? 'register' : 'login')}
                        >
                            {isLogin ? "Créer un compte" : "Se connecter"}
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AuthModal;
